module.exports = __webpack_public_path__ + "static/media/plant.8d5671c9.svg";